<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
              <el-form-item label="平台类型">
<!--                  <el-input style="width: 177px;" v-model="queryForm.platformType"></el-input>-->
                  <el-select
                      style="width:177px"
                      v-model="queryForm.platformType"
                      size="small"
                      clearable
                      placeholder="请选择"
                  >
                      <el-option
                          v-for="(item,index) in paltformList"
                          :label="item.value"
                          :value="item.key"
                      > </el-option>
                  </el-select>
              </el-form-item>
              <el-form-item label="店铺名称">
                  <el-input style="width: 177px;" v-model="queryForm.shopName"></el-input>
              </el-form-item>
              <el-form-item label="订单分配方式">
<!--                  <el-input style="width: 177px;" v-model="queryForm.assignType"></el-input>-->
                  <el-select
                      style="width:177px"
                      v-model="queryForm.assignType"
                      size="small"
                      placeholder="请选择"
                      clearable
                  >
                      <el-option
                          v-for="(item,index) in assignList"
                          :label="item.value"
                          :value="item.key"
                      > </el-option>
                  </el-select>
              </el-form-item>
              <el-form-item label="工厂">
<!--                  <el-input style="width: 177px;" v-model="queryForm.factoryId"></el-input>-->
                  <GridSelectU style="width: 177px;" title="选择工厂" labelName="factoryName"
                               labelValue="id" :value="queryForm.factoryId" :limit='1' size='small'
                               placeholder='请选择工厂'
                               @getValue="getSearchValueFactory" :columns="FACTORY_code" :searchs="FACTORY_search"
                               dataListUrl="/washcloud/factory/findList" entityBeanName="washcloudFactory"
                               queryEntityUrl="/washcloud/factory/get">
                  </GridSelectU>
              </el-form-item>
              <el-form-item label="一级工厂">
<!--                  <el-input style="width: 177px;" v-model="queryForm.factoryId1"></el-input>-->
                  <GridSelectU style="width: 177px;" title="选择工厂" labelName="factoryName"
                               labelValue="id" :value="queryForm.factoryId1" :limit='1' size='small'
                               placeholder='请选择工厂'
                               @getValue="getSearchValueFactory1" :columns="FACTORY_code" :searchs="FACTORY_search"
                               dataListUrl="/washcloud/factory/findList" entityBeanName="washcloudFactory"
                               queryEntityUrl="/washcloud/factory/get">
                  </GridSelectU>
              </el-form-item>
              <el-form-item label="二级工厂">
<!--                  <el-input style="width: 177px;" v-model="queryForm.factoryId2"></el-input>-->
                  <GridSelectU style="width: 177px;" title="选择工厂" labelName="factoryName"
                               labelValue="id" :value="queryForm.factoryId2" :limit='1' size='small'
                               placeholder='请选择工厂'
                               @getValue="getSearchValueFactory2" :columns="FACTORY_code" :searchs="FACTORY_search"
                               dataListUrl="/washcloud/factory/findList" entityBeanName="washcloudFactory"
                               queryEntityUrl="/washcloud/factory/get">
                  </GridSelectU>
              </el-form-item>
              <el-form-item label="三级工厂">
<!--                  <el-input style="width: 177px;" v-model="queryForm.factoryId3"></el-input>-->
                  <GridSelectU style="width: 177px;" title="选择工厂" labelName="factoryName"
                               labelValue="id" :value="queryForm.factoryId3" :limit='1' size='small'
                               placeholder='请选择工厂'
                               @getValue="getSearchValueFactory3" :columns="FACTORY_code" :searchs="FACTORY_search"
                               dataListUrl="/washcloud/factory/findList" entityBeanName="washcloudFactory"
                               queryEntityUrl="/washcloud/factory/get">
                  </GridSelectU>
              </el-form-item>
              <el-form-item label="四级工厂">
<!--                  <el-input style="width: 177px;" v-model="queryForm.factoryId4"></el-input>-->
                  <GridSelectU style="width: 177px;" title="选择工厂" labelName="factoryName"
                               labelValue="id" :value="queryForm.factoryId4" :limit='1' size='small'
                               placeholder='请选择工厂'
                               @getValue="getSearchValueFactory4" :columns="FACTORY_code" :searchs="FACTORY_search"
                               dataListUrl="/washcloud/factory/findList" entityBeanName="washcloudFactory"
                               queryEntityUrl="/washcloud/factory/get">
                  </GridSelectU>
              </el-form-item>
              <el-form-item label="五级工厂">
<!--                  <el-input style="width: 177px;" v-model="queryForm.factoryId5"></el-input>-->
                  <GridSelectU style="width: 177px;" title="选择工厂" labelName="factoryName"
                               labelValue="id" :value="queryForm.factoryId5" :limit='1' size='small'
                               placeholder='请选择工厂'
                               @getValue="getSearchValueFactory5" :columns="FACTORY_code" :searchs="FACTORY_search"
                               dataListUrl="/washcloud/factory/findList" entityBeanName="washcloudFactory"
                               queryEntityUrl="/washcloud/factory/get">
                  </GridSelectU>
              </el-form-item>
              <el-form-item label="六级工厂">
<!--                  <el-input style="width: 177px;" v-model="queryForm.factoryId6"></el-input>-->
                  <GridSelectU style="width: 177px;" title="选择工厂" labelName="factoryName"
                               labelValue="id" :value="queryForm.factoryId6" :limit='1' size='small'
                               placeholder='请选择工厂'
                               @getValue="getSearchValueFactory6" :columns="FACTORY_code" :searchs="FACTORY_search"
                               dataListUrl="/washcloud/factory/findList" entityBeanName="washcloudFactory"
                               queryEntityUrl="/washcloud/factory/get">
                  </GridSelectU>
              </el-form-item>
              <el-form-item label="快递类型">
<!--                  <el-input style="width: 177px;" v-model="queryForm.deliveryType"></el-input>-->
                  <el-select
                      style="width:177px"
                      v-model="queryForm.deliveryType"
                      size="small"
                      placeholder="请选择"
                      clearable
                  >
                      <el-option
                          v-for="(item,index) in deliveryList"
                          :label="item.value"
                          :value="item.key"
                      > </el-option>
                  </el-select>
              </el-form-item>
              <el-form-item label="平台隶属">
<!--                  <el-input  v-model="queryForm.userId"></el-input>-->
                  <GridSelectU style="width: 177px;" title="选择管理员" labelName="userName"
                               labelValue="id" :value="queryForm.userId" :limit='1' size='small'
                               placeholder='请选择用户'
                               @getValue="getSearchValueUser" :columns="USER_code" :searchs="USER_search"
                               dataListUrl="/mpp/user/findList" entityBeanName="mppUser"
                               queryEntityUrl="/mpp/user/get">
                  </GridSelectU>
              </el-form-item>
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getWashcloudPlatformFactoryList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="addWashcloudPlatformFactory"
        >新建</el-button>
        <el-button
          type="warning"
          plain
          size="small"
          icon="el-icon-edit"
          :disabled="multipleSelection.length != 1"
          @click="editWashcloudPlatformFactory(null)"
        >修改</el-button>
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deleteWashcloudPlatformFactory(null)"
        >删除</el-button>
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
        <span
          class="icon-box"
          @click="refreshWashcloudPlatformFactoryList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="washcloudPlatformFactoryList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="platformType"
        label="平台类型"
        width="180"
      >
          <template slot-scope="scope">
              {{ returnPaltform(scope.row.platformType) }}
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="shopName"
        label="店铺名称"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="provinceId"
        label="地址"
        width="180"
      >
          <template slot-scope="scope">
              <div v-if='scope.row.province'>
                  {{ scope.row.province.areaName }}{{ scope.row.city.areaName }}{{ scope.row.area.areaName }}
              </div>

              <div v-else>--</div>
          </template>
      </el-table-column>
<!--      <el-table-column-->
<!--        :show-overflow-tooltip="true"-->
<!--        align="center"-->
<!--        prop="cityId"-->
<!--        label="市"-->
<!--        width="180"-->
<!--      > </el-table-column>-->
<!--      <el-table-column-->
<!--        :show-overflow-tooltip="true"-->
<!--        align="center"-->
<!--        prop="areaId"-->
<!--        label="区"-->
<!--        width="180"-->
<!--      > </el-table-column>-->
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="assignType"
        label="订单分配方式"
        width="180"
      >
          <template slot-scope="scope">
              {{ returnAssign(scope.row.assignType) }}
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="factoryId"
        label="工厂"
        width="180"
      >
          <template slot-scope="scope">
              <div v-if='scope.row.factory'>
                  {{ scope.row.factory.factoryName }}
              </div>

              <div v-else>--</div>
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="factoryId1"
        label="一级工厂"
        width="180"
      >
          <template slot-scope="scope">
              <div v-if='scope.row.factory1'>
                  {{ scope.row.factory1.factoryName }}
              </div>
              <div v-else>--</div>
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="factoryId2"
        label="二级工厂"
        width="180"
      >
          <template slot-scope="scope">
              <div v-if='scope.row.factory2'>
                  {{ scope.row.factory2.factoryName }}
              </div>
              <div v-else>--</div>
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="factoryId3"
        label="三级工厂"
        width="180"
      >
          <template slot-scope="scope">
              <div v-if='scope.row.factory3'>
                  {{ scope.row.factory3.factoryName }}
              </div>
              <div v-else>--</div>
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="factoryId4"
        label="四级工厂"
        width="180"
      >
          <template slot-scope="scope">
              <div v-if='scope.row.factory4'>
                  {{ scope.row.factory4.factoryName }}
              </div>
              <div v-else>--</div>
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="factoryId5"
        label="五级工厂"
        width="180"
      >
          <template slot-scope="scope">
              <div v-if='scope.row.factory5'>
                  {{ scope.row.factory5.factoryName }}
              </div>
              <div v-else>--</div>
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="factoryId6"
        label="六级工厂"
        width="180"
      >
          <template slot-scope="scope">
              <div v-if='scope.row.factory6'>
                  {{ scope.row.factory6.factoryName }}
              </div>
              <div v-else>--</div>
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="deliveryType"
        label="快递类型"
        width="180"
      >
          <template slot-scope="scope">
              {{ returnDelivery(scope.row.deliveryType) }}
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="userId"
        label="平台隶属"
        width="180"
      >
          <template slot-scope="scope">
              <div v-if="scope.row.user">
                  <div style="text-align: left">账号：{{ scope.row.user.userName }}</div>
                  <div style="text-align: left">手机：{{ scope.row.user.userMobile }}</div>
                  <div style="text-align: left">昵称：{{ scope.row.user.userNickname }}</div>
                  <div style="text-align: left">姓名：{{ scope.row.user.userRealname }}</div>
              </div>
              <div v-else>--</div>
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="createTime"
        label="创建时间"
        width="180"
      > </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="300"
      >
        <template slot-scope="scop">
          <div class="operation">
            <div @click="checkWashcloudPlatformFactory(scop.row.id)">
              <Icon size="16">
                <Eye24Regular />
              </Icon>
              <span class="operation-label">查看</span>
            </div>
            <div @click="editWashcloudPlatformFactory(scop.row.id)">
              <Icon size="16">
                <Edit24Regular />
              </Icon>
              <span class="operation-label">修改</span>
            </div>
            <div @click="deleteWashcloudPlatformFactory(scop.row.id)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span class="operation-label" style="color: red">删除</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="washcloudPlatformFactoryStates[washcloudPlatformFactoryState]"
      :visible.sync="showDialog"
      width="60%"
      @close="closeDialog"
    >
      <div>
        <el-form
          :model="washcloudPlatformFactory"
          ref="washcloudPlatformFactoryForm"
          :rules="rules"
          label-width="80px"
          :inline="true"
          size="small"
        >
          <el-form-item
            label="平台类型"
            prop="platformType"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              style="width: 177px;"-->
<!--              v-model="washcloudPlatformFactory.platformType"-->
<!--              :disabled="washcloudPlatformFactoryState == 'check'"-->
<!--            ></el-input>-->
              <el-select
                  style="width:177px"
                  v-model="washcloudPlatformFactory.platformType"
                  size="small"
                  clearable
                  placeholder="请选择"
                  :disabled="washcloudPlatformFactoryState == 'check'"
              >
                  <el-option
                      v-for="(item,index) in paltformList"
                      :label="item.value"
                      :value="item.key"
                  > </el-option>
              </el-select>
          </el-form-item>
          <el-form-item
            label="店铺名称"
            prop="shopName"
          >
            <el-input
              size="small"
              style="width: 177px;"
              v-model="washcloudPlatformFactory.shopName"
              :disabled="washcloudPlatformFactoryState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="所属省份"
            prop="provinceId"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              style="width: 177px;"-->
<!--              v-model="washcloudPlatformFactory.provinceId"-->
<!--              :disabled="washcloudPlatformFactoryState == 'check'"-->
<!--            ></el-input>-->
              <el-select
                  placeholder='请选择省'
                  @change="clearSubitem('province')"
                  clearable
                  style='width: 177px'
                  size='small'
                  v-model='washcloudPlatformFactory.provinceId'
                  :disabled="washcloudPlatformFactoryState == 'check'"
              >
                  <el-option
                      v-for='(item,index) in provinceArry'
                      :key='index'
                      :label='item.areaName'
                      :value='item.id'
                  >
                  </el-option>
              </el-select>
          </el-form-item>
          <el-form-item
            label="所属城市"
            prop="cityId"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              style="width: 177px;"-->
<!--              v-model="washcloudPlatformFactory.cityId"-->
<!--              :disabled="washcloudPlatformFactoryState == 'check'"-->
<!--            ></el-input>-->
              <el-select
                  placeholder='请选择市'
                  @change="clearSubitem('city')"
                  clearable
                  style='width: 177px'
                  size='small'
                  v-model='washcloudPlatformFactory.cityId'
                  :disabled="washcloudPlatformFactoryState == 'check'"
              >
                  <el-option
                      v-for='(item,index) in cityArry'
                      :key='index'
                      :label='item.areaName'
                      :value='item.id'
                  >
                  </el-option>
              </el-select>
          </el-form-item>
          <el-form-item
            label="所属区县"
            prop="areaId"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              style="width: 177px;"-->
<!--              v-model="washcloudPlatformFactory.areaId"-->
<!--              :disabled="washcloudPlatformFactoryState == 'check'"-->
<!--            ></el-input>-->
              <el-select
                  placeholder='请选择区县'
                  clearable
                  style='width: 177px'
                  size='small'
                  v-model='washcloudPlatformFactory.areaId'
                  :disabled="washcloudPlatformFactoryState == 'check'"
              >
                  <el-option
                      v-for='(item,index) in areaArry'
                      :key='index'
                      :label='item.areaName'
                      :value='item.id'
                  >
                  </el-option>
              </el-select>
          </el-form-item>
          <el-form-item
            label="订单分配方式"
            prop="assignType"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              style="width: 177px;"-->
<!--              v-model="washcloudPlatformFactory.assignType"-->
<!--              :disabled="washcloudPlatformFactoryState == 'check'"-->
<!--            ></el-input>-->
              <el-select
                  style="width:177px"
                  v-model="washcloudPlatformFactory.assignType"
                  size="small"
                  clearable
                  placeholder="请选择"
                  :disabled="washcloudPlatformFactoryState == 'check'"
              >
                  <el-option
                      v-for="(item,index) in assignList"
                      :label="item.value"
                      :value="item.key"
                  > </el-option>
              </el-select>
          </el-form-item>
          <el-form-item
            label="工厂"
            prop="factoryId"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              style="width: 177px;"-->
<!--              v-model="washcloudPlatformFactory.factoryId"-->
<!--              :disabled="washcloudPlatformFactoryState == 'check'"-->
<!--            ></el-input>-->
              <GridSelectU style="width: 177px;" title="选择工厂" labelName="factoryName" :disabled="washcloudPlatformFactoryState == 'check'"
                           labelValue="id" :value="washcloudPlatformFactory.factoryId" :limit='1' size='small'
                           placeholder='请选择工厂'
                           @getValue="getValueFactory" :columns="FACTORY_code" :searchs="FACTORY_search"
                           dataListUrl="/washcloud/factory/findList" entityBeanName="washcloudFactory"
                           queryEntityUrl="/washcloud/factory/get">
              </GridSelectU>
          </el-form-item>
          <el-form-item
            label="一级工厂"
            prop="factoryId1"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              style="width: 177px;"-->
<!--              v-model="washcloudPlatformFactory.factoryId1"-->
<!--              :disabled="washcloudPlatformFactoryState == 'check'"-->
<!--            ></el-input>-->
              <GridSelectU style="width: 177px;" title="选择工厂" labelName="factoryName" :disabled="washcloudPlatformFactoryState == 'check'"
                           labelValue="id" :value="washcloudPlatformFactory.factoryId1" :limit='1' size='small'
                           placeholder='请选择工厂'
                           @getValue="getValueFactory1" :columns="FACTORY_code" :searchs="FACTORY_search"
                           dataListUrl="/washcloud/factory/findList" entityBeanName="washcloudFactory"
                           queryEntityUrl="/washcloud/factory/get">
              </GridSelectU>
          </el-form-item>
          <el-form-item
            label="二级工厂"
            prop="factoryId2"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              style="width: 177px;"-->
<!--              v-model="washcloudPlatformFactory.factoryId2"-->
<!--              :disabled="washcloudPlatformFactoryState == 'check'"-->
<!--            ></el-input>-->
              <GridSelectU style="width: 177px;" title="选择工厂" labelName="factoryName" :disabled="washcloudPlatformFactoryState == 'check'"
                           labelValue="id" :value="washcloudPlatformFactory.factoryId2" :limit='1' size='small'
                           placeholder='请选择工厂'
                           @getValue="getValueFactory2" :columns="FACTORY_code" :searchs="FACTORY_search"
                           dataListUrl="/washcloud/factory/findList" entityBeanName="washcloudFactory"
                           queryEntityUrl="/washcloud/factory/get">
              </GridSelectU>
          </el-form-item>
          <el-form-item
            label="三级工厂"
            prop="factoryId3"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              style="width: 177px;"-->
<!--              v-model="washcloudPlatformFactory.factoryId3"-->
<!--              :disabled="washcloudPlatformFactoryState == 'check'"-->
<!--            ></el-input>-->
              <GridSelectU style="width: 177px;" title="选择工厂" labelName="factoryName" :disabled="washcloudPlatformFactoryState == 'check'"
                           labelValue="id" :value="washcloudPlatformFactory.factoryId3" :limit='1' size='small'
                           placeholder='请选择工厂'
                           @getValue="getValueFactory3" :columns="FACTORY_code" :searchs="FACTORY_search"
                           dataListUrl="/washcloud/factory/findList" entityBeanName="washcloudFactory"
                           queryEntityUrl="/washcloud/factory/get">
              </GridSelectU>
          </el-form-item>
          <el-form-item
            label="四级工厂"
            prop="factoryId4"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              style="width: 177px;"-->
<!--              v-model="washcloudPlatformFactory.factoryId4"-->
<!--              :disabled="washcloudPlatformFactoryState == 'check'"-->
<!--            ></el-input>-->
              <GridSelectU style="width: 177px;" title="选择工厂" labelName="factoryName" :disabled="washcloudPlatformFactoryState == 'check'"
                           labelValue="id" :value="washcloudPlatformFactory.factoryId4" :limit='1' size='small'
                           placeholder='请选择工厂'
                           @getValue="getValueFactory4" :columns="FACTORY_code" :searchs="FACTORY_search"
                           dataListUrl="/washcloud/factory/findList" entityBeanName="washcloudFactory"
                           queryEntityUrl="/washcloud/factory/get">
              </GridSelectU>
          </el-form-item>
          <el-form-item
            label="五级工厂"
            prop="factoryId5"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              style="width: 177px;"-->
<!--              v-model="washcloudPlatformFactory.factoryId5"-->
<!--              :disabled="washcloudPlatformFactoryState == 'check'"-->
<!--            ></el-input>-->
              <GridSelectU style="width: 177px;" title="选择工厂" labelName="factoryName" :disabled="washcloudPlatformFactoryState == 'check'"
                           labelValue="id" :value="washcloudPlatformFactory.factoryId5" :limit='1' size='small'
                           placeholder='请选择工厂'
                           @getValue="getValueFactory5" :columns="FACTORY_code" :searchs="FACTORY_search"
                           dataListUrl="/washcloud/factory/findList" entityBeanName="washcloudFactory"
                           queryEntityUrl="/washcloud/factory/get">
              </GridSelectU>
          </el-form-item>
          <el-form-item
            label="六级工厂"
            prop="factoryId6"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              style="width: 177px;"-->
<!--              v-model="washcloudPlatformFactory.factoryId6"-->
<!--              :disabled="washcloudPlatformFactoryState == 'check'"-->
<!--            ></el-input>-->
              <GridSelectU style="width: 177px;" title="选择工厂" labelName="factoryName" :disabled="washcloudPlatformFactoryState == 'check'"
                           labelValue="id" :value="washcloudPlatformFactory.factoryId6" :limit='1' size='small'
                           placeholder='请选择工厂'
                           @getValue="getValueFactory6" :columns="FACTORY_code" :searchs="FACTORY_search"
                           dataListUrl="/washcloud/factory/findList" entityBeanName="washcloudFactory"
                           queryEntityUrl="/washcloud/factory/get">
              </GridSelectU>
          </el-form-item>
          <el-form-item
            label="快递类型"
            prop="deliveryType"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              style="width: 177px;"-->
<!--              v-model="washcloudPlatformFactory.deliveryType"-->
<!--              :disabled="washcloudPlatformFactoryState == 'check'"-->
<!--            ></el-input>-->
              <el-select
                  style="width:177px"
                  v-model="washcloudPlatformFactory.deliveryType"
                  size="small"
                  clearable
                  placeholder="请选择"
                  :disabled="washcloudPlatformFactoryState == 'check'"
              >
                  <el-option
                      v-for="(item,index) in deliveryList"
                      :label="item.value"
                      :value="item.key"
                  > </el-option>
              </el-select>
          </el-form-item>
          <el-form-item
            label="平台隶属"
            prop="userId"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="washcloudPlatformFactory.userId"-->
<!--              :disabled="washcloudPlatformFactoryState == 'check'"-->
<!--            ></el-input>-->
              <GridSelectU style="width: 177px;" title="选择管理员" labelName="userName"
                           :disabled="washcloudPlatformFactoryState == 'check'"
                           labelValue="id" :value="washcloudPlatformFactory.userId" :limit='1' size='small'
                           placeholder='请选择用户'
                           @getValue="getValueUser" :columns="USER_code" :searchs="USER_search"
                           dataListUrl="/mpp/user/findList" entityBeanName="mppUser"
                           queryEntityUrl="/mpp/user/get">
              </GridSelectU>
          </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="washcloudPlatformFactoryState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';
import GridSelectU from '@/components/gridselect/index.vue';
import { USER, USER_SEARCH, FACTORY, FACTORY_SEARCH } from '@/utils/constant';

export default {
    components: {
        GridSelectU,
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetWashcloudPlatformFactoryList();
                    this.getWashcloudPlatformFactoryList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetWashcloudPlatformFactoryList();
                    this.getWashcloudPlatformFactoryList();
                    this.$emit('resetCheckState');
                }
            }
        },
    computed: {
        provinceArry() {
            return this.areaTreeDate;
        },
        cityArry() {
            if (!this.provinceArry) {
                return [];
            } else {
                for (let i = 0; i < this.provinceArry.length; i++) {
                    if (this.provinceArry[i].id == this.washcloudPlatformFactory.provinceId) {
                        return this.provinceArry[i].children;
                    } else if (this.washcloudPlatformFactory.provinceId == '') {
                        return [];
                    }
                }
            }
        },
        areaArry() {
            if (!this.cityArry) {
                return [];
            } else {
                for (let i = 0; i < this.cityArry.length; i++) {
                    if (this.cityArry[i].id == this.washcloudPlatformFactory.cityId) {
                        return this.cityArry[i].children;
                    }
                }
            }
        }
    },
    data() {
            return {
                queryForm:{
                     platformType: '', //平台类型
                     shopName: '', //店铺名称
                     provinceId: '', //省
                     cityId: '', //市
                     areaId: '', //区
                     assignType: '', //订单分配方式
                     factoryId: '', //工厂
                     factoryId1: '', //一级工厂
                     factoryId2: '', //
                     factoryId3: '', //
                     factoryId4: '', //
                     factoryId5: '', //
                     factoryId6: '', //
                     deliveryType: '', //快递类型
                     userId: '', //平台隶属
                },
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                washcloudPlatformFactoryState: 'add',
                washcloudPlatformFactoryStates: {
                    add: '新建网络平台',
                    check: '查看网络平台',
                    edit: '修改网络平台'
                },
                USER_code: USER,
                USER_search: USER_SEARCH,
                FACTORY_code: FACTORY,
                FACTORY_search: FACTORY_SEARCH,
                multipleSelection: [],
                washcloudPlatformFactoryList: [],
                washcloudPlatformFactory: {
                    id: '', //
                    platformType: '', //平台类型
                    shopName: '', //店铺名称
                    provinceId: '', //省
                    cityId: '', //市
                    areaId: '', //区
                    assignType: '', //订单分配方式
                    factoryId: '', //
                    factoryId1: '', //
                    factoryId2: '', //
                    factoryId3: '', //
                    factoryId4: '', //
                    factoryId5: '', //
                    factoryId6: '', //
                    deliveryType: '', //快递类型
                    userId: '', //平台隶属
                },
                btnLoading: false,
                areaTreeDate: [],
                rules: {
                    platformType: [{ required: true, message: '平台类型不能为空', trigger: 'blur' }],
                    shopName: [{ required: true, message: '店铺名称不能为空', trigger: 'blur' }],
                    provinceId: [{ required: true, message: '省不能为空', trigger: 'blur' }],
                    cityId: [{ required: true, message: '市不能为空', trigger: 'blur' }],
                    areaId: [{ required: true, message: '区不能为空', trigger: 'blur' }],
                    assignType: [{ required: true, message: '订单分配方式不能为空', trigger: 'blur' }],
                    factoryId: [{ required: true, message: '不能为空', trigger: 'blur' }],
                    factoryId1: [{ required: true, message: '不能为空', trigger: 'blur' }],
                    factoryId2: [{ required: true, message: '不能为空', trigger: 'blur' }],
                    factoryId3: [{ required: true, message: '不能为空', trigger: 'blur' }],
                    factoryId4: [{ required: true, message: '不能为空', trigger: 'blur' }],
                    factoryId5: [{ required: true, message: '不能为空', trigger: 'blur' }],
                    factoryId6: [{ required: true, message: '不能为空', trigger: 'blur' }],
                    deliveryType: [{ required: true, message: '快递类型不能为空', trigger: 'blur' }],
                    userId: [{ required: true, message: '平台隶属不能为空', trigger: 'blur' }],
                },
                paltformList: [],
                assignList: [],
                deliveryList: [],
            };
        },
        created() {
            this.getWashcloudPlatformFactoryList();
            this.getTreeData();
            this.getEnum();
        },
        methods: {
            search(){
                this.isSearch = !this.isSearch;
            },
            getEnum(){
                get('/washcloud/utils/getEnum', { enumType: 'platform_type' }).then(res=>{
                    if(res.success){
                        this.paltformList = res.enumList;
                    }
                })
                get('/washcloud/utils/getEnum', { enumType: 'assign_type' }).then(res=>{
                    if(res.success){
                        this.assignList = res.enumList;
                    }
                })
                get('/washcloud/utils/getEnum', { enumType: 'delivery_type' }).then(res=>{
                    if(res.success){
                        this.deliveryList = res.enumList;
                    }
                })
            },
            returnPaltform(key){
                for (let item in this.paltformList) {
                    if(this.paltformList[item].key == key){
                        return this.paltformList[item].value;
                    }
                }
            },
            returnAssign(key){
                for (let item in this.assignList) {
                    if(this.assignList[item].key == key){
                        return this.assignList[item].value;
                    }
                }
            },
            returnDelivery(key){
                for (let item in this.deliveryList) {
                    if(this.deliveryList[item].key == key){
                        return this.deliveryList[item].value;
                    }
                }
            },
            clearSubitem(id) {
                if (id == 'province') {
                    this.washcloudPlatformFactory.cityId = '';
                    this.washcloudPlatformFactory.areaId = '';
                } else if (id == 'city') {
                    this.washcloudPlatformFactory.areaId = '';
                }
            },
            getTreeData() {
                get('/mpp/area/treeData').then((res) => {
                    if (res.success) {
                        this.areaTreeDate = res.treeData[0].children;
                    }
                });
            },
            resetWashcloudPlatformFactoryList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.washcloudPlatformFactoryList = [];
            },



            getSearchValueFactory(val){
                this.queryForm.factoryId = val;
            },
            getValueFactory(value) {
                this.washcloudPlatformFactory.factoryId = value;
            },

            getSearchValueFactory1(val){
                this.queryForm.factoryId1 = val;
            },
            getValueFactory1(value) {
                this.washcloudPlatformFactory.factoryId1 = value;
            },

            getSearchValueFactory2(val){
                this.queryForm.factoryId2 = val;
            },
            getValueFactory2(value) {
                this.washcloudPlatformFactory.factoryId2 = value;
            },

            getSearchValueFactory3(val){
                this.queryForm.factoryId3 = val;
            },
            getValueFactory3(value) {
                this.washcloudPlatformFactory.factoryId3 = value;
            },

            getSearchValueFactory4(val){
                this.queryForm.factoryId4 = val;
            },
            getValueFactory4(value) {
                this.washcloudPlatformFactory.factoryId4 = value;
            },

            getSearchValueFactory5(val){
                this.queryForm.factoryId5 = val;
            },
            getValueFactory5(value) {
                this.washcloudPlatformFactory.factoryId5 = value;
            },

            getSearchValueFactory6(val){
                this.queryForm.factoryId6 = val;
            },
            getValueFactory6(value) {
                this.washcloudPlatformFactory.factoryId6 = value;
            },



            getValueUser(value) {
                this.washcloudPlatformFactory.userId = value;
            },
            getSearchValueUser(value) {
                this.queryForm.userId = value;
            },
            resetDialog() {
                this.washcloudPlatformFactoryState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      platformType: '', //平台类型
                      shopName: '', //店铺名称
                      provinceId: '', //省
                      cityId: '', //市
                      areaId: '', //区
                      assignType: '', //订单分配方式
                      factoryId: '', //
                      factoryId1: '', //
                      factoryId2: '', //
                      factoryId3: '', //
                      factoryId4: '', //
                      factoryId5: '', //
                      factoryId6: '', //
                      deliveryType: '', //快递类型
                      userId: '', //平台隶属
                };
                this.getWashcloudPlatformFactoryList();
            },
            closeDialog() {
                this.showDialog = false
                this.washcloudPlatformFactory = {
                      id: '', //
                      platformType: '', //平台类型
                      shopName: '', //店铺名称
                      provinceId: '', //省
                      cityId: '', //市
                      areaId: '', //区
                      assignType: '', //订单分配方式
                      factoryId: '', //
                      factoryId1: '', //
                      factoryId2: '', //
                      factoryId3: '', //
                      factoryId4: '', //
                      factoryId5: '', //
                      factoryId6: '', //
                      deliveryType: '', //快递类型
                      userId: '', //平台隶属
                };
            },
            submitForm() {
                if (this.washcloudPlatformFactoryState == 'add') {
                    this.$refs.washcloudPlatformFactoryForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/washcloud/platformfactory/add`,{ ...this.washcloudPlatformFactory }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetWashcloudPlatformFactoryList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.washcloudPlatformFactoryState == 'edit') {
                    this.$refs.washcloudPlatformFactoryForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/washcloud/platformfactory/edit`,{ ...this.washcloudPlatformFactory }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetWashcloudPlatformFactoryList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addWashcloudPlatformFactory() {
                this.showDialog = true;
                this.washcloudPlatformFactoryState = 'add';
            },
            checkWashcloudPlatformFactory(washcloudPlatformFactoryId) {
                console.log(washcloudPlatformFactoryId);
                this.currentWashcloudPlatformFactoryId = washcloudPlatformFactoryId;

                this.getWashcloudPlatformFactoryById();
                this.showDialog = true;
                this.washcloudPlatformFactoryState = 'check';
            },
            editWashcloudPlatformFactory(washcloudPlatformFactoryId) {
                console.log('washcloudPlatformFactory', washcloudPlatformFactoryId);
                if (washcloudPlatformFactoryId) {
                    this.currentWashcloudPlatformFactoryId = washcloudPlatformFactoryId;
                    this.getWashcloudPlatformFactoryById();
                } else {
                    this.washcloudPlatformFactory = { ...this.washcloudPlatformFactory, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.washcloudPlatformFactoryState = 'edit';
            },
            deleteWashcloudPlatformFactory(washcloudPlatformFactoryId) {
                let ids = '';
                if (washcloudPlatformFactoryId) {
                    ids = washcloudPlatformFactoryId;
                } else {
                    ids = this.multipleSelection.map((washcloudPlatformFactory) => washcloudPlatformFactory.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/washcloud/platformfactory/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetWashcloudPlatformFactoryList();
                                this.getWashcloudPlatformFactoryList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshWashcloudPlatformFactoryList() {
                this.resetWashcloudPlatformFactoryList();
                this.getWashcloudPlatformFactoryList();
            },
            getWashcloudPlatformFactoryList(query = {}) {
                this.loading = true;
                get(`/washcloud/platformfactory/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.washcloudPlatformFactoryList = res.page.list;
                        this.totalNum = res.page.total;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getWashcloudPlatformFactoryById() {
                get(`/washcloud/platformfactory/get`,{ id: this.currentWashcloudPlatformFactoryId }).then((res) =>{
                    if(res.success){
                      this.washcloudPlatformFactory = { ...this.washcloudPlatformFactory, ...res.washcloudPlatformFactory };
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportWashcloudPlatformFactoryList() {
                //this.btnLoading = true;
                exprotExcel(`/washcloud/platformfactory/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/washcloud/platformfactory/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/washcloud/platformfactory/importData`,formData);
              this.refreshWashcloudPlatformFactoryList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getWashcloudPlatformFactoryList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getWashcloudPlatformFactoryList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>